import React, { useCallback, useEffect, useState } from 'react';
import Modal from '../Templates/ModalsTemplates/Modal';
import Tabela from '../Templates/Tabela01';
import axios from 'axios';

const urlServidor = process.env.REACT_APP_SERVIDOR;
let previousUsuario = -1;
let currentProjeto;
let usuario;
// Variárel que ficará responsável por armazenar o antigo cd;
let oldCd;

const MudarCd =({ newProjeto, filtro }) => {
    
    const [projeto, setProjeto] = useState({});
    const [qtdCds, setQtdCds] = useState(0);
    const [cds, setCds] = useState([]);

    useEffect(() => {
        currentProjeto = JSON.parse(sessionStorage.getItem('projeto'));
        usuario = JSON.parse(sessionStorage.getItem('user'));
        oldCd = JSON.parse(sessionStorage.getItem('cd'));
    }, []);

    useEffect(() => {
        setProjeto(newProjeto || currentProjeto);
    }, [newProjeto]);
    
    useEffect(() => {
        const cod = usuario.cod_usuario || projeto.usuario;
        if(previousUsuario !== cod && cod){
            previousUsuario = cod;
            axios.post(`${urlServidor}/Usercds`, {'cod_usuario': cod, 'busca': '','pagina': 0,'qtd_reg': ''})
                .then(resp => {setCds(resp.data.cds); setQtdCds(resp.data.qtd_cds);})
                .catch(error => console.log(error));
        }
    }, [projeto, usuario]);

    const handleRowClick = useCallback((e) => {
        const prevToken = sessionStorage.getItem('token');
        const user = sessionStorage.getItem('user');
        sessionStorage.clear();
        sessionStorage.setItem('user', user);
        sessionStorage.setItem('cd', JSON.stringify(e.data));
        sessionStorage.setItem('qtd_cds', JSON.stringify(qtdCds));
        if(projeto){
            sessionStorage.setItem('projeto', JSON.stringify(projeto));
            sessionStorage.setItem('token', projeto.token_jwt_web);
        }
        else {
            sessionStorage.setItem('token', prevToken);
        }
        window.location.replace('/inicio');
    }, [projeto, qtdCds]);

    const handleKeyDown = useCallback((e) => {
        if(e.key === 'Enter'){
            const tableData = cds.filter(cd => String(cd.cod_cd).includes(filtro.watch('filtro')) || cd.nome_cd.includes(filtro.watch('filtro')));
            if(tableData.length){
                handleRowClick({ data: tableData[0] });
            };
        };
    }, [cds, handleRowClick]);

    const Content = useCallback(() => {
        return (
            <>
                <div className="pesquisa d-flex align-items-baseline mb-2">
                    <p className='m-0'>Filtro: </p>
                    <input className='form-control form-control-sm ms-1' type="text" placeholder="Digite o nome ou o código do seu CD" {...filtro.register('filtro', { onChange: e => filtro.setValue('filtro', e.target.value.toUpperCase()) })} autoComplete='off' onKeyDown={handleKeyDown} />
                </div>
                <Tabela  columns={[
                    {datafield: 'cod_cd', caption: 'ID', width: 80, defaultSortOrder: 'asc'},
                    {datafield: 'nome_cd', caption: 'Nome'}
                    ]}
                    data={cds.filter(cd => String(cd.cod_cd).includes(filtro.watch('filtro')) || cd.nome_cd.includes(filtro.watch('filtro')))}
                    onRowClick={handleRowClick} 
                    disableHeaderFilter 
                    disableSearchPanel
                    height='370'
                />
            </>
        );
    }, [handleRowClick, cds, oldCd]);

    return(
        <Modal size='lg' content={<Content />} id="mudar-cd-modal" title="Mudar CD" />
    );
};

export default MudarCd;